<template>
  <v-app>
    <v-main class="fullscreen-main">
      <!-- Direct to dashboard - Authentication handled by Cloudflare Zero Trust -->
      <DashboardView />
    </v-main>
  </v-app>
</template>

<script>
import DashboardView from './views/DashboardView.vue'

export default {
  name: 'App',
  components: {
    DashboardView
  }
}
</script>

<style scoped>
.fullscreen-main {
  padding: 0 !important;
}

/* Remove default padding from v-main when in fullscreen mode */
:deep(.v-main__wrap) {
  height: 100vh;
}
</style>